import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectService {

  constructor() { }
  private subject = new Subject<any>();

  onSelectionChange(data): void {
      this.subject.next(data);
  }

  selectServiceSubscription(): Observable<any> {
      return this.subject.asObservable();
  }
}
